import { QuestionType, IQuestionListItem, IUserAnswerMap } from '@/types';
import { isQuestionDone } from '@/utils';

export const initialQuestionList = (questionList: IQuestionListItem[]) => {
    let initialActiveQuestionId = 0;
    let initialActiveSubQuestionId = 0;
    const initializeUserAnswerMap: IUserAnswerMap = {};

    const loop = (dataSource: IQuestionListItem[], parentQuestionId?: number) => {
        dataSource.forEach(question => {
            if (question.questionType === QuestionType.comprehensive) {
                loop(question.subQuestionList, question.questionId);
            } else if (question.userAnswer && isQuestionDone(question.userAnswer)) {
                initializeUserAnswerMap[question.questionId] = {
                    questionType: question.questionType,
                    ...question.userAnswer,
                };
            } else if (!initialActiveQuestionId) {
                if (parentQuestionId) {
                    initialActiveQuestionId = parentQuestionId;
                    initialActiveSubQuestionId = question.questionId;
                } else {
                    initialActiveQuestionId = question.questionId;
                }
            }
        });
    };

    loop(questionList);

    if (!initialActiveQuestionId && questionList.length) {
        const lastQuestion = questionList[questionList.length - 1];

        initialActiveQuestionId = lastQuestion.questionId;
        initialActiveSubQuestionId = lastQuestion.subQuestionList?.length
            ? lastQuestion.subQuestionList[lastQuestion.subQuestionList.length - 1].questionId
            : 0;
    }

    return {
        initialActiveQuestionId,
        initialActiveSubQuestionId,
        initializeUserAnswerMap,
    };
};

export const initialQuestionAnalysisList = (questionList: IQuestionListItem[]) => {
    const initializeUserAnswerMap: IUserAnswerMap = {};
    const loop = (dataSource: IQuestionListItem[]) => {
        dataSource.forEach(question => {
            if (question.questionType === QuestionType.comprehensive) {
                loop(question.subQuestionList);
            } else if (question.userAnswer) {
                initializeUserAnswerMap[question.questionId] = {
                    questionType: question.questionType,
                    ...question.userAnswer,
                };
            }
        });
    };
    loop(questionList);
    return initializeUserAnswerMap;
};
